import React from "react"
import Select from "react-select"
import { useTranslation } from "react-i18next"

const GuestsPopup = ({ name, value, setValue }: any) => {
  const { t } = useTranslation()

  const options = [
    { value: "Reminder only", label: t("reminders.reminderOnly") },
    {
      value: "Reminder with option to decline or accept invitation",
      label: t("reminders.reminderWithOption"),
    },
    {
      value: "QR Code Reminder",
      label: t("reminders.qrCodeReminder"),
    },
  ]
  return (
    <Select
      // menuIsOpen={true}
      classNamePrefix="select-guest"
      options={options}
      value={options.find((e) => e.value === value)}
      onChange={(option) => {
        setValue(option?.value)
      }}
      styles={{
        container: (state: any) => ({
          ...state,
          display: name === "desktop" ? "block" : "none",
          width: "100%",
          maxWidth: "456px",
          zIndex: 10,
          minHeight: "26px",
          "@media (max-width: 1279px)": {
            maxWidth: "356px",
          },
          "@media (max-width: 991px)": {
            display: name === "desktop" ? "none" : "block",
            maxWidth: "100%",
          },
        }),
        valueContainer: (state: any) => ({
          ...state,
          padding: "0px 10px 0px 0px",
          height: "26px",
          "@media (max-width: 1279px)": {
            height: "16px",
          },
          "@media (max-width: 991px)": {
            maxWidth: "90%",
            height: "100%",
          },
        }),
        control: (state: any) => ({
          ...state,
          fontSize: "14px",
          lineHeight: "26px",
          border: 0,
          boxShadow: "none",
          borderBottom: "1px solid #E3E2E2",
          "&:hover": {
            borderBottom: "1px solid #E3E2E2",
          },
          borderRadius: "",
          paddingBottom: "11px",
          "@media (max-width: 1279px)": {
            fontSize: "12px",
            lineHeight: "16px",
            minHeight: "16px",
          },
        }),
        singleValue: (state: any) => ({
          ...state,
          "@media (max-width: 991px)": {
            whiteSpace: "wrap",
          },
        }),
        indicatorSeparator: () => ({
          display: "none",
        }),

        dropdownIndicator: (base: any, state) => ({
          ...base,
          padding: "0px",
          transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
          "@media (max-width: 1279px)": {
            height: "16px",
          },
        }),
        option: (defaultStyles: any, state: any) => ({
          ...defaultStyles,
          fontSize: "16px",
          "@media (max-width: 1279px)": {
            fontSize: "12px",
          },
          lineHeight: "22.4px",
          position: "relative",
          backgroundColor: state.isSelected ? "#F2F4F7" : "#FFF",
          "&:hover": {
            background: "#F2F4F7",
          },
          "&::after": {
            content: state.isSelected ? "url(/vector/check.svg)" : '""',
            position: "absolute",
            right: "10px",
            top: "calc(50% - 8px)",
            width: "16px",
            height: "16px",
          },
          padding: "10px 11px",
          "@media (max-width: 991px)": {
            padding: "6px 36px 6px 10px",
          },
          color: "#0B0C0E",
        }),

        menu: (state: any) => ({
          ...state,
          boxShadow:
            "0 0 0 0px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
          borderRadius: "0",
        }),
        menuList: (state: any) => ({
          ...state,
          padding: "0",
        }),
      }}
    />
  )
}

export default GuestsPopup
